import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-meatball': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M48 352C21.5 352 0 373.5 0 400S21.5 448 48 448 96 426.5 96 400 74.5 352 48 352zM464 352C437.5 352 416 373.5 416 400S437.5 448 464 448 512 426.5 512 400 490.5 352 464 352zM345 363.1C349.6 348.6 346.6 332.3 335.2 320.8 323.7 309.3 307.4 306.4 292.9 310.9 285.9 297.4 272.2 287.9 256 287.9S226.1 297.4 219.1 310.9C204.6 306.3 188.3 309.3 176.8 320.8 165.3 332.3 162.4 348.6 166.9 363.1 153.4 370.1 143.9 383.8 143.9 400S153.4 429.9 166.9 436.9C162.3 451.4 165.3 467.7 176.8 479.2 185 487.4 195.7 491.5 206.5 491.5 210.8 491.5 215 490.4 219.1 489 226.1 502.5 239.8 512 256 512S285.9 502.5 292.9 489C297 490.3 301.2 491.5 305.5 491.5 316.3 491.5 327 487.4 335.2 479.2 346.7 467.7 349.6 451.4 345 436.9 358.5 429.9 368 416.2 368 400S358.5 370.1 345 363.1zM512 224C512 171 469 128 416 128 415.4 128 414.9 128.2 414.4 128.2 415.5 123 416 117.6 416 112 416 67.8 380.2 32 336 32 311.4 32 289.7 43.3 275 60.8 256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112 64 119.3 64.8 126.3 66.1 133.2 27.8 145.8 0 181.5 0 224 0 277 43 320 96 320H139.4C143 312 147.8 304.6 154.2 298.2 167.7 284.7 185.7 277.1 205 276.9 218.5 263.7 236.7 256 256 256S293.5 263.7 307 276.9C326.3 277.1 344.3 284.7 357.8 298.2 364.2 304.6 369.1 312 372.6 320H416C469 320 512 277 512 224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-meatball.js
// module id = FXhK
// module chunks = 144